import React, { useEffect, useState, useRef } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "../styles/payments.css";
import Loading from "../helpers/loading_component.js";
import emailjs from "@emailjs/browser";
import { secretKey } from "../.././data";

const MySwal = withReactContent(Swal2);

const ClientAssignLawyer = (props) => {
  const [lawyer, setLawyer] = useState(props.lawyer);
  const [loading, setLoading] = useState(false);

  const handleLawyerChange = (e) => {
    setLawyer(e.target.value);
  };

  const assignLawyer = async (e) => {
    if (validateAssign()) {
      setLoading(true);

      var body = {
        client_owner: lawyer,
      };

      await fetch("https://apidevkppp.ftpeople.pl/assignLawyerClient", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then((data) => {})
        .catch((error) => {});

      props.logClientAction("Przypisano prawnika", props.clientId);

      MySwal.fire({
        icon: "success",
        title: "Przypisano",
        text: "prawnika",
      }).then((result) => {
        props.close();
      });
    } else {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wypełnij wymagane pola formularza",
      });
    }
  };

  const validateAssign = () => {
    if (lawyer.length > 0) {
      return true;
    }
    return false;
  };

  return (
    <>
      <div className="mainContainerAddSygn">
        {loading ? (
          <Loading id="popUpLoading" />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>

            <div id="addPaymentIC" className="inputContainer">
              <div className="inputBox">
                <div className="inputCol_3">
                  <label>
                    Prawnik prowadzący <span className="requiredStar">*</span>
                  </label>
                  <select
                    type="text"
                    id="court"
                    name="court"
                    value={lawyer}
                    onChange={handleLawyerChange}
                  >
                    {props.lawyersData.map((el) => (
                      <option key={el.initials} value={el.initials}>
                        {el.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="saveBoxAP">
                <button className="paymentMenuButton" onClick={assignLawyer}>
                  zapisz
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default ClientAssignLawyer;
